import { ChartSymbol } from '../context/chart/chartTypes';

const chartSymbolMapper: Record<ChartSymbol, string> = {
    BTCUSDC: 'BTCUSD',
    ETHUSDC: 'ETHUSD',
    LINKUSDC: 'LINKUSD',
    BNBUSDC: 'BNBUSD',
    XRPUSDC: 'XRPUSD',
    ADAUSDC: 'ADAUSD',
    MATICUSDC: 'MATICUSD',
    DOTUSDC: 'DOTUSD',
    ARBUSDC: 'ARBUSD',
    DOGEUSDC: 'DOGEUSD',
    UNIUSDC: 'UNIUSD',
};

const chartSymbolToRouteParam = <T extends boolean | undefined>(
    key: T extends true ? string : ChartSymbol,
    reverse: T
) => {
    const reversed = Object.entries(chartSymbolMapper).reduce((acc, [key, value]) => {
        return {
            ...acc,
            [value]: key as ChartSymbol,
        };
    }, {} as Record<string, ChartSymbol>);

    return reverse ? reversed[key] : chartSymbolMapper[key as ChartSymbol];
};

export default chartSymbolToRouteParam;
